import React, { useState } from 'react';

import { Fab } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import EntryPopup from './entryPopup';
import AddMenu from './addMenu';
import EntryTable from './entryTable';

import { collection, doc, getDocs } from "firebase/firestore";
import { database } from '../firebaseConfig2';

//get collection info
const querySnapshot = await getDocs(collection(database, "statuses"));


export default function Status() {

//table info

const columns = [
  { id: 'type', label: 'type', minWidth: 170 },
  { id: 'message', label: 'Message', minWidth: 100 },
];

const rows = [];
querySnapshot.forEach((doc) => {
  let temprow =
    {
      id: doc.id, 
      type: doc.data().type, 
      message: doc.data().message
    }
    if (!rows.includes(temprow)){
      rows.push(temprow);
    }
});

//other
  const [addMenu, setAddMenu] = useState(false);
  const [updater, triggerUpdate] = useState(0);
  const [entryPopup, openPopup] = useState(false);
  const [selectedRow, setSelectedRow] = useState();

  const handleMenu = (mybool) =>{
    setAddMenu(true);
    console.log("inhandlemenu")
  }
  return (
    <>
        <EntryTable querySnapshot={querySnapshot} columns={columns} rows={rows} tableName="statuses" updater={updater}  entryPopup={entryPopup} openPopup={openPopup} selectedRow={selectedRow} setSelectedRow={setSelectedRow}/>
        <div style={{ display: entryPopup ? 'block' : 'none' }}>
          <EntryPopup querySnapshot={querySnapshot} tableName="statuses" entryPopup={entryPopup} openPopup={openPopup} selectedRow={selectedRow} setSelectedRow={setSelectedRow}/>
        </div>
        <Fab id="addbtn" color="primary" aria-label="add" onClick={()=>handleMenu(true)}>
          <AddIcon />
        </Fab>
        <div className='menucontainer' style={{ display: addMenu ? 'block' : 'none' }}>
          <AddMenu querySnapshot={querySnapshot} tableName="statuses" addMenu={addMenu} setAddMenu={setAddMenu} updater={updater} triggerUpdate={triggerUpdate}/>
        </div>
    </>
  );
}